module.exports = __webpack_public_path__ + "static/media/16.65e4ab69.png";